import * as React from 'react';
import { Toast } from 'antd-mobile';
import intl from 'react-intl-universal';

import * as api from '@services/api';
import { action, observable } from 'mobx';

export class ComponentExt<P = {}, S = {}> extends React.Component<P, S> {
    readonly $api = api;
    readonly $toast = Toast;
    readonly $intl = intl;
}

export class StoreExt {
    readonly $api = api;
    readonly $toast = Toast;
    readonly $intl = intl;

    @observable loading = observable.map<string, boolean>({});

    @action
    handleLoading = (type: string, value: boolean) => {
        this.loading.set(type, value);
    };
}

export const Loading = (target: any, key: any, descriptor: any) => {
    const oldValue = descriptor.value;
    descriptor.value = async function (...args: any[]) {
        this.handleLoading(key, true);
        let res;
        try {
            res = await oldValue.apply(this, args);
        } catch (error) {
            throw error;
        } finally {
            this.handleLoading(key, false);
        }
        return res;
    };
    return descriptor;
};
